module.exports = __webpack_public_path__ + "img/Ticker-X-Black.98906dbd.svg";